export default {
    label_task:{
        en:"Vendors",
        bn:'ব্যবহারকারীরা'
    },
    label_new_task:{
        en:"New Vendor",
        bn:'নতুন ব্যবহারকারী'
    },
    label_edit_task:{
        en:"Edit Vendor",
        bn:'সম্পাদনা ব্যবহারকারী'
    },
    label_details_task:{
        en:"Details of Vendor",
        bn:'ব্যবহারকারীর বিবরণ'
    },
    label_phone_number:{
        en:"Phone Number",
        bn:"প্রিফিক্স"
    },
    label_zip_code:{
        en:"Zip Code",
        bn:"প্রিফিক্স"
    },
}